
import axios from 'axios';

const client = axios.create({
    baseURL: `${import.meta.env.VITE_REACT_API_BASE_URL}/api/v1`,
    timeout: 30000,
});

const getErrorResponse = (error) => {

    const responseError = error.response?.data?.message;

    return { error: responseError || error.message, data: [] };
}

export async function getProductVersions() {
    try {
        const response = await client.get('/product-version-groups');
        return { error: null, data: response.data };
    } catch (error) {
        return getErrorResponse(error);
    }
}

export async function getProductVersionsPromise() {
    return client.get('/product-version-groups')
        .then(response => {
            return { error: null, data: response.data };
        })
        .catch(error => getErrorResponse(error));
}

export async function getProduct(userChoice) {
    try {
        const response = await client.get('/products', {
            params: {
                dimension_type: userChoice.measureType,
                width: userChoice.width,
                height: userChoice.height,
                frame_sides_areo: userChoice.product.frame_sides_areo,
                opening_areo: userChoice.product.opening_areo,
                lock_predisposition: userChoice.product.lock_predisposition,
            }
        });
        return { error: null, data: response.data };
    } catch (error) {
        return getErrorResponse(error);
    }
}

export async function getAccessories(productId, accessoryType, selectedAccessoryIds: number[] = []) {
    try {
        const response = await client.get(`/products/${productId}/accessories`, {
            params: {
                accessory_type: accessoryType,
                selected_accessory_ids: selectedAccessoryIds,
            }
        });
        return { error: null, data: response.data };
    } catch (error) {
        return getErrorResponse(error);
    }
}